import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from 'react-toastify';
import { GET_COUPON_FAILED,GET_COUPON_REQUESTED, GET_COUPON_SUCCESS, GET_ADDCOUPON_FAILED, GET_ADDCOUPON_REQUESTED, GET_ADDCOUPON_SUCCESS, GET_UPDATECOUPON_FAILED, GET_UPDATECOUPON_REQUESTED, GET_UPDATECOUPON_SUCCESS, GET_DELETECOUPON_FAILED, GET_DELETECOUPON_REQUESTED,GET_DELETECOUPON_SUCCESS} from "resources/actionTypes";
import { couponApi, addCouponApi, updateCouponApi, deleteApi } from "services/CouponService";
import store from "redux/store";
import { getCoupon } from "redux/actions/UserCouponAction";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* fetchCoupon(action) {
  try {
    const payload = action.payload || {}
    const userCoupon = yield call(couponApi, payload);
    yield put({
      type: GET_COUPON_SUCCESS,
      userCoupon: userCoupon
    });
  } catch (e) {
    yield put({
      type: GET_COUPON_FAILED,
      message: e.message
    })
    toast.error(e.message || 'Get Coupon Failed')
  }
}

export function* couponSaga() {
  yield takeEvery(GET_COUPON_REQUESTED,
    fetchCoupon);
}

function* fetchAddCoupon(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userAddCoupon = yield call(addCouponApi, payload.userAddCoupon);
  if (userAddCoupon.success) {
    yield put({ type: GET_ADDCOUPON_SUCCESS, userAddCoupon: userAddCoupon });
    toast.success(userAddCoupon.message);
    store.dispatch(onLoaderTrigger(false));
    payload.setOpen()
    store.dispatch(getCoupon())
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_ADDCOUPON_FAILED, message: userAddCoupon.message });
      toast.error(userAddCoupon.message || 'Add Coupon failed');
  }
}

export function* addCouponSaga() {
  yield takeEvery(GET_ADDCOUPON_REQUESTED, fetchAddCoupon);
}

function* fetchUpdateCoupon(action) {
  const payload = action.payload || {};
  
  store.dispatch(onLoaderTrigger(true));
  const userUpdateCoupon = yield call(updateCouponApi, payload.userUpdateCoupon, payload.id);
  
  if (userUpdateCoupon.success) {
    yield put({ type: GET_UPDATECOUPON_SUCCESS, userUpdateCoupon: userUpdateCoupon });
    toast.success(userUpdateCoupon.message);
    store.dispatch(onLoaderTrigger(false));
    
    // Refresh the list with current filters
    store.dispatch(getCoupon({
      page: payload.userUpdateCoupon.page,
      pageSize: payload.userUpdateCoupon.pageSize,
      search: payload.userUpdateCoupon.search,
      status: payload.userUpdateCoupon.status
    }));
    // Close the form
    if (payload.setOpen) {
      payload.setOpen(false);
    }
  } else {
    store.dispatch(onLoaderTrigger(false));
    yield put({
      type: GET_UPDATECOUPON_FAILED,
      message: userUpdateCoupon.message
    });
    toast.error(userUpdateCoupon.message || 'Update Coupon failed');
  }
}

export function* updateCouponSaga() {
  yield takeEvery(GET_UPDATECOUPON_REQUESTED, fetchUpdateCoupon);
}

function* fetchDeleteCoupon(action) {
    const payload = action.payload || {}
    store.dispatch(onLoaderTrigger(true));
    const userDeleteCoupon = yield call(deleteApi, payload?.couponID?.id);
    if(userDeleteCoupon.success){
      yield put({ type: GET_DELETECOUPON_SUCCESS, userDeleteCoupon: userDeleteCoupon });
      toast.success(userDeleteCoupon.message);

      if(payload?.key === "couponTable") {
        store.dispatch(getCoupon(payload?.couponID?.filterData));
        payload.setOpenConfirm();
      }
      else {
        payload?.redirect();
      }
    // Call store.getCouponApi here
    
   
    }
    else{
      yield put({ type: GET_DELETECOUPON_FAILED, message: userDeleteCoupon.message });
        toast.error(userDeleteCoupon.message || 'Delete Coupon failed');
    } 
    store.dispatch(onLoaderTrigger(false));
  }

export function* deleteCouponSaga() {
  yield takeEvery(GET_DELETECOUPON_REQUESTED,
    fetchDeleteCoupon);
}
